module.exports = new __parcel__URL__("create-template.4960343d.png").toString();